import { DateTime } from 'luxon';
import ITimeRange from 'types/TimeRange';
import { isNilOrEmpty } from 'utils/collectionUtils';
import { remainingDataItemId } from 'utils/constants/utilConstants';

export function timeEntryEquipmentOrAddOnFilter(
  timeRange: ITimeRange<DateTime>,
  includeOpenTimeEntries: boolean,
  ids?: string[] | null,
  equipmentCategoryId?: string | null
) {
  if (isNilOrEmpty(ids)) return undefined;

  let equipmentIdFilter;
  if (ids!.includes(remainingDataItemId)) {
    equipmentIdFilter = { isNull: true };
  } else if (ids!.length === 1) {
    equipmentIdFilter = { equal: ids![0] };
  } else {
    equipmentIdFilter = { contains: ids };
  }

  return {
    startTime: timeRange.startTime.startOf('day').toUTC().toISO({ suppressMilliseconds: true, includeOffset: false }),
    endTime: timeRange.endTime.endOf('day').toUTC().toISO({ suppressMilliseconds: true, includeOffset: false }),
    includeOpenTimeEntries,
    equipmentId: equipmentIdFilter,
    equipmentCategoryId: equipmentCategoryId ? { equal: equipmentCategoryId } : undefined,
  };
}
